export const aboutTheService = {
    title: 'サービスについて',
    overview: 'サービス概要',
    overviewText:
        '世界の知財情報を有効活用し、根拠のあるスピーディな経営戦略の立案を支援。\n未来への意思決定をサポートする知財戦略支援分析ツールです。',
    canDo: 'Intelligent Business Analyticsでできること',
    canDoTitle1: '直感的にトレンドテーマにおける世の中の技術動向がわかる',
    canDoDescription1:
        'Intelligent Business Analyticsは特許情報を経営戦略に活かすための分析ツールです。\n昨今の急激な社会変化に対応していくためには、より多面的な視点で経営戦略を策定することが重要と言われています。\nIBAは、世界中から特許、財務、出資金額など膨大な情報のデータを独自のAIが解析し、特定技術テーマにおける世界の技術動向を直感的にわかりやすく提示します。',
    canDoTitle2: '影響力のある技術要素の特定及び、自社の立ち位置、該当技術に強みを持つ企業までスピーディに調査できる',
    canDoDescription2:
        '独自の解析ロジックにより、技術テーマを構成している技術要素が、技術の進展度と市場からの注目度の観点でどのポジションに位置しているかを確認できます。\nまた、紐づいている特許技術やその保有企業、さらに企業の経営情報まで一貫した分析ができます。\n自社の特許出願状況との比較も行えるので、技術の強みや弱みを補完する最適なアライアンス先や投資先企業の選定業務にかかる時間や手間を大幅に短縮できます。',
    canDoTitle3: '技術動向から市場が注目している想定顧客、課題、ニーズを考察し、より深い提供価値を得ることができる',
    canDoDescription3:
        '自社の新規事業参入の検討や市場の技術動向の調査において、特許という客観的な事実データから根拠の肉付けを行うことができます。\nまた、分析結果を起点に、市場が注目している想定顧客や課題、ニーズをより深く考察し、一段階深い考察や市場のモニタリングが可能です。'
}
